var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
import styled from 'styled-components';
import { typographyCss } from './typographyCss';
var fontWeightMap = {
    inherit: 'inherit',
    normal: '400',
    semiBold: '500',
    bold: '700',
};
/**
 * @deprecated Use `typographyCss` instead. Semantic heading elements
 * do not map 1:1 to heading styles.
 */
var Heading1 = styled.h1(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  margin-top: 0;\n  margin-bottom: 0;\n  ", "\n"], ["\n  margin-top: 0;\n  margin-bottom: 0;\n  ", "\n"])), typographyCss.Heading1);
/**
 * @deprecated Use `typographyCss` instead. Semantic heading elements
 * do not map 1:1 to heading styles.
 */
var Heading2 = styled.h2(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n  margin-top: 0;\n  margin-bottom: 0;\n  ", "\n"], ["\n  margin-top: 0;\n  margin-bottom: 0;\n  ", "\n"])), typographyCss.Heading2);
/**
 * @deprecated Use `typographyCss` instead. Semantic heading elements
 * do not map 1:1 to heading styles.
 */
var Heading3 = styled.h3(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n  margin-top: 0;\n  margin-bottom: 0;\n  ", "\n"], ["\n  margin-top: 0;\n  margin-bottom: 0;\n  ", "\n"])), typographyCss.Heading3);
/**
 * @deprecated Use `typographyCss` instead. Semantic heading elements
 * do not map 1:1 to heading styles.
 */
var Heading4 = styled.h4(templateObject_4 || (templateObject_4 = __makeTemplateObject(["\n  margin-top: 0;\n  margin-bottom: 0;\n  ", "\n"], ["\n  margin-top: 0;\n  margin-bottom: 0;\n  ", "\n"])), typographyCss.Heading4);
/**
 * @deprecated Use `typographyCss` instead. Semantic heading elements
 * do not map 1:1 to heading styles.
 */
var Heading5 = styled.h5(templateObject_5 || (templateObject_5 = __makeTemplateObject(["\n  margin-top: 0;\n  margin-bottom: 0;\n  ", "\n"], ["\n  margin-top: 0;\n  margin-bottom: 0;\n  ", "\n"])), typographyCss.Heading5);
/**
 * @deprecated Use `typographyCss` instead. Semantic heading elements
 * do not map 1:1 to heading styles.
 */
var Heading6 = styled.h6(templateObject_6 || (templateObject_6 = __makeTemplateObject(["\n  margin-top: 0;\n  margin-bottom: 0;\n  ", "\n"], ["\n  margin-top: 0;\n  margin-bottom: 0;\n  ", "\n"])), typographyCss.Heading6);
/**
 * @deprecated Use `typographyCss` instead.
 */
var Title1 = styled.span(templateObject_7 || (templateObject_7 = __makeTemplateObject(["\n  ", "\n"], ["\n  ", "\n"])), typographyCss.Title1);
/**
 * @deprecated Use `typographyCss` instead.
 */
var Title2 = styled.span(templateObject_8 || (templateObject_8 = __makeTemplateObject(["\n  ", "\n"], ["\n  ", "\n"])), typographyCss.Title2);
/**
 * @deprecated Use `typographyCss` instead.
 */
var Subtitle = styled.span(templateObject_9 || (templateObject_9 = __makeTemplateObject(["\n  ", "\n"], ["\n  ", "\n"])), typographyCss.Subtitle);
/**
 * @deprecated Use `typographyCss` instead.
 */
var Body1 = styled.span(templateObject_10 || (templateObject_10 = __makeTemplateObject(["\n  ", "\n  font-weight: ", ";\n"], ["\n  ", "\n  font-weight: ", ";\n"])), typographyCss.Body1, function (_a) {
    var _b = _a.fontWeight, fontWeight = _b === void 0 ? 'inherit' : _b;
    return fontWeightMap[fontWeight];
});
/**
 * @deprecated Use `typographyCss` instead.
 */
var Body2 = styled.span(templateObject_11 || (templateObject_11 = __makeTemplateObject(["\n  ", "\n  font-weight: ", ";\n"], ["\n  ", "\n  font-weight: ", ";\n"])), typographyCss.Body2, function (_a) {
    var _b = _a.fontWeight, fontWeight = _b === void 0 ? 'inherit' : _b;
    return fontWeightMap[fontWeight];
});
/**
 * @deprecated Use `typographyCss` instead.
 */
var Body3 = styled.span(templateObject_12 || (templateObject_12 = __makeTemplateObject(["\n  ", "\n  font-weight: ", ";\n"], ["\n  ", "\n  font-weight: ", ";\n"])), typographyCss.Body3, function (_a) {
    var _b = _a.fontWeight, fontWeight = _b === void 0 ? 'inherit' : _b;
    return fontWeightMap[fontWeight];
});
/**
 * @deprecated Use `typographyCss` instead.
 */
var Small = styled.span(templateObject_13 || (templateObject_13 = __makeTemplateObject(["\n  ", "\n"], ["\n  ", "\n"])), typographyCss.Small);
/**
 * @deprecated Use `typographyCss` instead.
 */
var Tiny = styled.span(templateObject_14 || (templateObject_14 = __makeTemplateObject(["\n  ", "\n"], ["\n  ", "\n"])), typographyCss.Tiny);
/**
 * @deprecated Use `typographyCss` instead.
 */
var Overline1 = styled.span(templateObject_15 || (templateObject_15 = __makeTemplateObject(["\n  ", "\n"], ["\n  ", "\n"])), typographyCss.Overline1);
/**
 * @deprecated Use `typographyCss` instead.
 */
var Overline2 = styled.span(templateObject_16 || (templateObject_16 = __makeTemplateObject(["\n  ", "\n"], ["\n  ", "\n"])), typographyCss.Overline2);
/**
 * @deprecated Use `typographyCss` instead.
 */
var Overline3 = styled.span(templateObject_17 || (templateObject_17 = __makeTemplateObject(["\n  ", "\n"], ["\n  ", "\n"])), typographyCss.Overline3);
/**
 * @deprecated Use `typographyCss` instead.
 */
var Overline4 = styled.span(templateObject_18 || (templateObject_18 = __makeTemplateObject(["\n  ", "\n"], ["\n  ", "\n"])), typographyCss.Overline4);
/**
 * @deprecated Use `typographyCss` instead.
 */
var Quote1 = styled.span(templateObject_19 || (templateObject_19 = __makeTemplateObject(["\n  ", "\n"], ["\n  ", "\n"])), typographyCss.Quote1);
/**
 * @deprecated Use `typographyCss` instead.
 */
var Quote2 = styled.span(templateObject_20 || (templateObject_20 = __makeTemplateObject(["\n  ", "\n"], ["\n  ", "\n"])), typographyCss.Quote2);
export { Heading1, Heading2, Heading3, Heading4, Heading5, Heading6, Title1, Title2, Subtitle, Body1, Body2, Body3, Small, Tiny, Overline1, Overline2, Overline3, Overline4, Quote1, Quote2, };
var templateObject_1, templateObject_2, templateObject_3, templateObject_4, templateObject_5, templateObject_6, templateObject_7, templateObject_8, templateObject_9, templateObject_10, templateObject_11, templateObject_12, templateObject_13, templateObject_14, templateObject_15, templateObject_16, templateObject_17, templateObject_18, templateObject_19, templateObject_20;
//# sourceMappingURL=index.js.map